/* eslint-disable react/style-prop-object */
import * as React from "react";
import { Button } from "@emisgroup/ui-kit-react";
import { useTranslation } from "@emisgroup/application-intl";
import "./multiSelectSelection.css";

type MultiSelectSelectionProps = {
    id: string;
    itemName: string;
    children?: React.ReactNode | React.ReactNodeArray;
    onRemove: () => void;
};

const MultiSelectSelection = ({ id, itemName, children, onRemove }: MultiSelectSelectionProps) => (
    <div className="multi-select-selection-container" data-testid={`multi-select-selection-${id}-${itemName}`}>
        <div className="multi-select-selection-header">
            <div className="multi-select-selection-name">{itemName}</div>
            <div className="multi-select-remove-selection">
                <Button
                    data-testid="multi-select-remove-button"
                    iconOnly
                    iconName="clear"
                    variant="secondary"
                    title={useTranslation().t("components.pickingList.removeSelection")}
                    onClick={onRemove}
                />
            </div>
        </div>
        {children}
    </div>
);

export default MultiSelectSelection;
